/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const s=s=>Math.round(1e5*s)/1e5,d=/(-)?([\d]*\.?[\d])+/g,r=/(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))/gi,t=/^(#[0-9a-f]{3,8}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2}(-?[\d\.]+%?)\s*[\,\/]?\s*[\d\.]*%?\))$/i;function n(s){return"string"==typeof s}export{r as colorRegex,d as floatRegex,n as isString,s as sanitize,t as singleColorRegex};
//# sourceMappingURL=utils.js.map
